function loadCSS(href) {
  if (!href) return;

  // al geladen als stylesheet?
  if (document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) return;

  // al in preload?
  if (document.querySelector('link[rel="preload"][as="style"][href="' + href + '"]')) return;

  var link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'style';
  link.href = href;

  link.onload = function () {
    link.rel = 'stylesheet';
    link.onload = null;
  };

  document.head.appendChild(link);
}
